import { render, staticRenderFns } from "./VueClamp.vue?vue&type=template&id=14f7d432&scoped=true&"
import script from "./VueClamp.vue?vue&type=script&lang=js&"
export * from "./VueClamp.vue?vue&type=script&lang=js&"
import style0 from "./VueClamp.vue?vue&type=style&index=0&id=14f7d432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f7d432",
  null
  
)

export default component.exports